import { ref } from 'vue'
import api from './api.js'
import sha256 from 'crypto-js/sha256'

export const useCaptcha = () => {
  const captchaPending = ref(false)
  const captchaError = ref(null)
  const captchaChallenge = ref('')
  const captchaPrefix = ref('')
  const captchaNonce = ref(0)
  const captchaSolved = ref(false)

  const fetchUrl = `captcha/challenge`

  function resetCaptcha() {
    captchaPending.value = false
    captchaError.value = null
    captchaChallenge.value = ''
    captchaPrefix.value = ''
    captchaNonce.value = 0
    captchaSolved.value = false
  }

  async function solvePuzzle(challenge, prefix) {
    console.log('Puzzle wird gelöst...', challenge, prefix)

    if (!challenge || !prefix) {
      console.error('Challenge oder captchaPrefix fehlen!')
      captchaError.value = true
      captchaPending.value = false
      return
    }

    captchaChallenge.value = challenge
    captchaPrefix.value = prefix.toLowerCase() // Hash liefert lowercase

    // zurücksetzen
    let hashHex = ''
    captchaNonce.value = 0

    // Schleife bis der Hash mit dem Prefix übereinstimmt
    while (!hashHex.startsWith(captchaPrefix.value)) {
      const input = captchaChallenge.value + captchaNonce.value
      hashHex = sha256(input).toString()
      captchaNonce.value++
    }

    // Wir sind aus der Schleife, weil der Hash endlich passt.
    // captchaNonce wurde am Ende der letzten Runde nochmal hochgezählt:
    captchaNonce.value--

    console.log('Puzzle gelöst!')
    console.log('captchaNonce:', captchaNonce.value)
    console.log('Hash:', hashHex)

    captchaSolved.value = true
    captchaPending.value = false
  }

  async function captchaSolve(captchaCase, baseUrl) {
    captchaPending.value = true
    captchaError.value = null
    captchaSolved.value = false

    let response = await api.get(baseUrl + fetchUrl + '?captchaCase=' + captchaCase)
    if (response) {
      console.log('Challenge Data:', response)
      await solvePuzzle(response.challenge, response.prefix)
    }
  }

  return {
    captchaNonce,
    captchaPending,
    captchaError,
    captchaChallenge,
    captchaPrefix,
    captchaSolved,
    captchaSolve,
    resetCaptcha,
  }
}
